import React from "react";
import { matchPath } from "react-router-dom";
import { zonedTimeToUtc } from "date-fns-tz";
import { FilterType } from "@/context/Table";
import { twMerge } from "tailwind-merge";
import clsx, { ClassValue } from "clsx";
export const hasPermission = (
  key: string,
  permissionList: Permission[]
): boolean => {
  let findIndex = permissionList.findIndex((p) => p.name === key);

  return findIndex !== -1 ? true : false;
};

export const toAbsoluteUrl = (pathname: string) =>
  import.meta.env.BASE_URL + pathname;

export const isPathActive = (pathname: string) => {
  let match = matchPath(
    { path: pathname, caseSensitive: true, end: false },
    window.location.pathname
  );

  return match ? true : false;
};

export const lazyImport: typeof React.lazy = (importer) => {
  const retryImport = async () => {
    try {
      return await importer();
    } catch (error) {
      // retry 5 times with 1 second delay
      for (let i = 0; i < 5; i++) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        try {
          return await importer();
        } catch (e) {
          console.log("retrying import");
        }
      }
      // Redirect to error 500
      window.location.replace("/error/500");
      throw error;
    }
  };
  return React.lazy(retryImport);
};

export function sendEmail(message: {
  from: string;
  emailId: string;
  subject: string;
}) {
  var email = message.emailId;
  var subject = message.subject;
  var emailBody = "Hi " + message.from + ", ";
  document.location =
    "mailto:" + email + "?subject=" + subject + "&body=" + emailBody;
}

export function getColumnType(f: FilterType) {
  return typeof f === "string" ? f : f.type;
}

export function generateUEID() {
  let first = (Math.random() * 46656) | 0;
  let second = (Math.random() * 46656) | 0;

  return (
    ("000" + first.toString(36)).slice(-3) +
    ("000" + second.toString(36)).slice(-3)
  );
}

export function isStringEmpty(subject: string, replaceWith: string = "N/A") {
  return subject === undefined || subject == null || subject.trim() === ""
    ? replaceWith
    : subject;
}

export function isEmpty(subject: any) {
  return subject === undefined ||
    subject === null ||
    (typeof subject === "string" && subject.trim() === "") ||
    (typeof subject === "number" && subject === 0)
    ? true
    : false;
}

export function getUtcDate(date: Date, tz: string) {
  return zonedTimeToUtc(date, tz);
}

export function getErrorFieldKey(key: string) {
  let newKey = key.split("");
  newKey[0] = newKey[0].toLowerCase();
  let keyChar = newKey.join("");
  return keyChar;
}
export function getDefaultFilterValue(
  filterValueType: "single" | "multiple",
  additionalData: any
) {
  let value: string | number | null | string[] = null;
  let filterType = getColumnType(additionalData);

  switch (filterType) {
    case "date":
      const _date = new Date();
      _date.setHours(0, 0, 0, 0);

      if (filterValueType === "single") {
        value = _date.getTime().toString();
        break;
      }

      // Multi
      value = [_date.getTime().toString()];
      break;
    case "boolean":
      if (filterValueType === "single") {
        value = "true";
        break;
      }

      value = additionalData?.additionalData?.map((e: any) => e?.value) ?? [
        "true",
      ];
      break;

    default:
      if (filterValueType === "single") {
        value = "";
        break;
      }

      value = [""];
      break;
  }

  return value;
}

export function setToEndOfDay(date: Date) {
  let endOfDay = new Date(date);

  endOfDay.setHours(23, 59, 59, 999);

  return endOfDay;
}

export function getTotalMsPerDay(date: Date) {
  const currentDayTotalMs =
    date.getHours() * 3600000 +
    date.getMinutes() * 60000 +
    date.getSeconds() * 1000 +
    date.getMilliseconds();
  const totalMs = date.getTime();
  const oneDayInMs = 86400000;
  return totalMs - currentDayTotalMs - 1 + oneDayInMs;
}

export function datediff(first: number, second: number) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
